import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatDateMMDDYYYY } from '../../../utils/formatUtils';
import type { StoreSummaryTableColumn } from '../../../types/features/storeSummaryListing';
import StoreSummaryBooleanCell from './StoreSummaryBooleanCell';
import StoreSummaryStoreCell from './StoreSummaryStoreCell';
import StoreSummarySubscriptionStatusCell from './StoreSummarySubscriptionStatusCell';

export const getStoreSummaryColumns = (): StoreSummaryTableColumn[] => [
  {
    id: 'name',
    labelLines: ['Stores'],
    align: 'left',
    sortable: true,
    getSortKey: () => 'name',
    renderCell: (row) => <StoreSummaryStoreCell row={row} />,
  },
  {
    id: 'owner',
    labelLines: ['Store', 'Owner'],
    align: 'left',
    sortable: true,
    getSortKey: () => 'owner',
    renderCell: (row) => (
      <Box>
        <Typography sx={{ fontSize: '13px', fontWeight: 400, lineHeight: 1.2 }}>{row.ownerName || '-'}</Typography>
      </Box>
    ),
  },
  {
    id: 'registrationDate',
    labelLines: ['Registration', 'Date'],
    align: 'left',
    sortable: true,
    getSortKey: () => 'registrationDate',
    renderCell: (row) => <Typography sx={{ fontSize: '13px', fontWeight: 400, lineHeight: 1.2 }}>{formatDateMMDDYYYY(row.registrationDate)}</Typography>,
  },
  {
    id: 'subscription_status',
    labelLines: ['Subscription', 'Status'],
    align: 'left',
    renderCell: (row) => <StoreSummarySubscriptionStatusCell status={row.subscription_status} />,
  },
  {
    id: 'remainingDays',
    labelLines: ['Remaining', 'Days'],
    align: 'right',
    sortable: true,
    getSortKey: () => 'remainingDays',
    renderCell: (row) => (
      <Typography sx={{ fontSize: '13px', fontWeight: 400, lineHeight: 1.2, textAlign: 'right' }}>
        {typeof row.remainingDays === 'number' && row.remainingDays > 0 ? row.remainingDays : '-'}
      </Typography>
    ),
  },
  {
    id: 'posSync',
    labelLines: ['POS'],
    width: 150,
    align: 'center',
    renderCell: (row) => <StoreSummaryBooleanCell value={row.posSync === 'Yes'} />,
  },
  {
    id: 'lotto_authorized',
    labelLines: ['Lotto'],
    width: 80,
    align: 'center',
    renderCell: (row) => <StoreSummaryBooleanCell value={Boolean(row.raw.lotto_authorized)} />,
  },
];
